document.addEventListener("DOMContentLoaded", function () {
  var menu = document.querySelector("[data-mobile-menu]");
  var nav = document.querySelector(".np-nav");
  if (menu && nav) {
    menu.addEventListener("click", function () {
      nav.classList.toggle("is-open");
      menu.setAttribute("aria-expanded", nav.classList.contains("is-open") ? "true" : "false");
    });
  }
});
